
import React from 'react';
import { Button } from '../../../components/base/Button';

export const HeroSection: React.FC = () => {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-900 via-gray-800 to-black">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://static.readdy.ai/image/8c697a09a607dd1bcfa59e74f239c1a2/61d972222a351a72ba79e577a52ba4a8.jpeg"
          alt="Comunidade brasileira e justiça social"
          className="w-full h-full object-cover object-top opacity-40"
        />
        <div className="absolute inset-0 bg-black bg-opacity-50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-6xl font-bold text-white mb-6 font-serif leading-tight">
            A Versão Oficial da Violência
          </h1>
          <p className="text-lg text-gray-300 mb-16 max-w-3xl mx-auto leading-relaxed">
            O levantamento realizado pela reportagem aponta que a maioria das notícias sobre mortes em operações policiais possuem apenas fontes oficiais, favorecendo narrativas de órgãos públicos de segurança. Em entrevista, a jornalista Cecília Olliveira e o mestre em comunicação Juarez Xavier explicam que o fenômeno acompanha a comunicação brasileira desde os primórdios
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Button 
              variant="secondary" 
              size="lg"
              className="bg-transparent border-2 border-white text-white hover:bg-white hover:text-gray-900 px-8 py-3 text-lg font-medium"
              onClick={() => scrollToSection('contrapontos')}
            >
              Leia a Investigação
            </Button>
            <Button 
              variant="secondary" 
              size="lg"
              className="bg-transparent border-2 border-white text-white hover:bg-white hover:text-gray-900 px-8 py-3 text-lg font-medium"
              onClick={() => scrollToSection('dados')}
            >
              Ver Dados
            </Button>
          </div>
        </div>

        {/* Statistics Banner */}
        <div className="mt-20 grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
          <div className="text-center">
            <div className="text-3xl md:text-4xl font-bold text-yellow-400 mb-2">50</div>
            <p className="text-gray-300 text-sm uppercase tracking-wide">Notícias de grandes veículos analisadas</p>
          </div>
          <div 
            className="text-center cursor-pointer hover:opacity-80 transition-opacity"
            onClick={() => scrollToSection('reportagem')}
          >
            <div className="text-3xl md:text-4xl font-bold text-yellow-400 mb-2">26,1%</div>
            <p className="text-gray-300 text-sm uppercase tracking-wide">apresentaram diversidade nas fontes e contraposições à narrativa dos órgãos de segurança pública</p>
          </div>
          <div className="text-center">
            <div className="text-3xl md:text-4xl font-bold text-yellow-400 mb-2">73,7%</div>
            <p className="text-gray-300 text-sm uppercase tracking-wide">DOS FATOS RETRATADOS OCORRERAM EM REGIÕES PERIFÉRICAS
</p>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
        <div className="animate-bounce">
          <i className="ri-arrow-down-line text-white text-2xl"></i>
        </div>
      </div>
    </section>
  );
};
